module.exports = __webpack_public_path__ + "static/media/kick_start_image.f8e57f50.svg";